import { AbstractControl, FormControl, FormGroup } from "@angular/forms";

import _merge from "lodash/merge";
import { Observable } from "rxjs";
import { merge } from "rxjs/internal/observable/merge";
import { map } from "rxjs/operators";

import { BaseObservableForm } from "../../../../shared-library/forms/base-observable.form";

import { MarketplaceSearchParametersModel } from "../models/marketplace-search-parameters.model";

export class MarketplaceSearchForm extends BaseObservableForm<MarketplaceSearchParametersModel> {
    public static createForm(
        initialSearchParams: MarketplaceSearchParametersModel,
        emptySearchParams: MarketplaceSearchParametersModel
    ): MarketplaceSearchForm {
        const formGroup = new FormGroup({
            searchTab: new FormControl(initialSearchParams.searchTab),

            searchText: new FormControl(initialSearchParams.searchText),
            sortOption: new FormControl(initialSearchParams.sortOption),
            pageNumber: new FormControl(initialSearchParams.pageNumber),
            pageSize: new FormControl(initialSearchParams.pageSize),

            categories: new FormControl(initialSearchParams.categories),
            areas: new FormControl(initialSearchParams.areas),
            minPrice: new FormControl(initialSearchParams.minPrice),
            maxPrice: new FormControl(initialSearchParams.maxPrice)
        });

        return new MarketplaceSearchForm(formGroup, initialSearchParams, emptySearchParams);
    }

    public get instance(): FormGroup { return this.formInstance; }

    public get searchText(): AbstractControl { return this.getFormControl("searchText"); }
    public get sortOption(): AbstractControl { return this.getFormControl("sortOption"); }
    public get pageNumber(): AbstractControl { return this.getFormControl("pageNumber"); }
    public get pageSize(): AbstractControl { return this.getFormControl("pageSize"); }

    public get categories(): AbstractControl { return this.getFormControl("categories"); }
    public get areas(): AbstractControl { return this.getFormControl("areas"); }
    public get minPrice(): AbstractControl { return this.getFormControl("minPrice"); }
    public get maxPrice(): AbstractControl { return this.getFormControl("maxPrice"); }

    protected constructor(
        formInstance: FormGroup,
        initialSearchParams: MarketplaceSearchParametersModel,
        private emptySearchParams: MarketplaceSearchParametersModel
    ) {
        super(formInstance, initialSearchParams);
    }

    protected bindOnChangeSubscription(): Observable<MarketplaceSearchParametersModel> {
        return merge(
            this.searchText.valueChanges.pipe(map((searchText: string) => ({
                searchText: searchText,
                pageNumber: 1
            }))),
            this.sortOption.valueChanges.pipe(map((sortOption: string) => ({
                searchText: this.initialFormState.searchText,
                sortOption: sortOption,
                pageNumber: 1
            }))),
            this.pageNumber.valueChanges.pipe(map((pageNumber: number) => ({
                searchText: this.initialFormState.searchText,
                pageNumber: pageNumber
            }))),
            this.pageSize.valueChanges.pipe(map((pageSize: number) => ({
                searchText: this.initialFormState.searchText,
                pageNumber: 1,
                pageSize: pageSize
            }))),
            this.categories.valueChanges.pipe(map((categories: Array<string>) => ({
                searchText: this.initialFormState.searchText,
                pageNumber: 1,
                categories: categories
            }))),
            this.areas.valueChanges.pipe(map((areas: Array<string>) => ({
                searchText: this.initialFormState.searchText,
                pageNumber: 1,
                areas: areas
            }))),
            this.minPrice.valueChanges.pipe(map((minPrice: string) => ({
                searchText: this.initialFormState.searchText,
                pageNumber: 1,
                minPrice: minPrice
            }))),
            this.maxPrice.valueChanges.pipe(map((maxPrice: string) => ({
                searchText: this.initialFormState.searchText,
                pageNumber: 1,
                maxPrice: maxPrice
            })))
        ).pipe(
            map(partialModel => this.getFormModel(partialModel))
        );
    }

    protected getFormModel(partialFormModel: any = {}): MarketplaceSearchParametersModel {
        return _merge(new MarketplaceSearchParametersModel(), super.getFormModel(partialFormModel));
    }

    public reset(): void {
        this.formInstance.patchValue(this.emptySearchParams, { emitEvent: false });
    }
}
